import { useMutation, useQueryClient } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { Oportunidade } from '../types';

interface OportunidadeUpsertInput {
  empresa_id: string;
  id?: string;
  payload: {
    estagio_id?: number;
    servico_id?: string;
    contato_principal_id?: string;
    valor_estimado_mensal_brl?: number;
    valor_vazamento_quantificado_brl_mes?: number;
    probabilidade?: number;
    data_proxima_acao?: string;
    acao_descricao?: string;
    proximo_movimento_recomendado?: string;
    motivo_perdido?: string;
    data_fechamento?: string;
  };
}

export function useOportunidadeUpsert() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: OportunidadeUpsertInput) => {
      return n8nFetch<Oportunidade>('/oportunidade-upsert', {
        method: 'POST',
        body: JSON.stringify(input),
      });
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['oportunidades', vars.empresa_id] });
    },
  });
}
